/**
 * Flat cancellation fee in EUR quoted by the measurement review's cancellation card. Hardcoded on
 * purpose: the amount is copy rather than a rate-card value, and the localized strings place the
 * currency symbol themselves.
 */
export const MEASUREMENT_CANCELLATION_FLAT_FEE_EUR = 100
